import { Maybe } from 'maybeasy';

/**
 * Guards the global `message` listeners against cross-origin postMessage
 * spoofing (DVLP-7368).
 *
 * A `postMessage` is only trusted when it actually came from the embedded
 * presentation/survey iframe: its `origin` must match the iframe's origin AND
 * its `source` must be the iframe's own `contentWindow`. Without this, any page
 * can `window.open` the P3 segment and post attacker-controlled payloads that
 * get forwarded into the authenticated results write flow.
 *
 * The `targetOrigin` argument an attacker passes to `postMessage` does not
 * affect the `origin`/`source` the browser reports here, so both checks defeat
 * the cross-origin opener attack.
 */
export const isTrustedFrameMessage = (
  e: MessageEvent,
  expectedOrigin: Maybe<string>,
  expectedSource: Window | null | undefined,
): boolean =>
  expectedOrigin
    .map((origin) => e.origin === origin && expectedSource != null && e.source === expectedSource)
    .getOrElseValue(false);
